import React from 'react';
import { useAuth } from "../../../context/auth";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme)=>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
}));

function DQCRTool_ViewAndEditPage() {
    const classes = useStyles();

    const {authUser} = useAuth();

    return (
        <div className={classes.container}>
            <h3>Landed on View and Edit Page</h3>
            <br />
            <p><b>Member_Id: {authUser.member_id}</b></p>
        </div>
    );
}

export default DQCRTool_ViewAndEditPage;